/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router';
// material
import { Division, InContentMessage, Page } from '@insticator/insticator-ui'; // iui-material
// pages
import TriviaAndPollsAnalyticsPage from './triviapollsanalytics/triviapollsanalytics'
import TriviaPollsConfigPage from './configuration/configuration';

// utils

// thunks

// styles
import injectSheet from 'react-jss';
import styles from './triviapolls_styles';



/* ========== ~~~~~~~~~~ TRIVIA & POLLS DIVISION ~~~~~~~~~~ ========== */

const TriviaAndPollsDivision = (props) => {
    // state

    // actions
    const dispatch = useDispatch();


    return(
        <Division name={`triviapolls`} klass={props.classes.triviapolls}>
            <Switch>
                {/*Routes to subdivisions*/}
                <Route exact path='/dashboard/triviapolls' render={() => <Redirect to={'dashboard/triviapolls/analytics'} />} />
                <Route path='/dashboard/triviapolls/analytics' component={TriviaAndPollsAnalyticsPage} />
                <Route path='/dashboard/triviapolls/configuration' component={TriviaPollsConfigPage} />
                <Redirect to='/error/404'/>
            </Switch>
        </Division>
    )
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(TriviaAndPollsDivision);

